import { createSelector, createSlice, Dictionary, PayloadAction } from '@reduxjs/toolkit';
import { toDictionary } from '@ff-os/shared-utils/dictionaries';
import { PdpState } from '../store';

type Owner = {
    readonly id: string;
    readonly name: string;
    readonly logoAssetId?: string;
};

type Resource = {
    type: string;
    content: {
        id: string;
        [key: string]: any;
    };
    owner: Owner | null;
};

export type ListResourcesResult = {
    resourceType: string;
    entries: Resource[];
};

export const { actions, reducer } = createSlice({
    name: 'resources',
    initialState: {} as Dictionary<any>,
    reducers: {

        replace: (state, action: PayloadAction<ListResourcesResult>) => {

            const resourceType = action.payload.resourceType;
            const resources = action.payload.entries
                .filter(e => e.type === resourceType)
                .map(e => addOwnerToResourceIfExists(e));

            state[resourceType] = toDictionary(resources, r => r.id);
        }
    }
});

const addOwnerToResourceIfExists = (resource: Resource) => {
    if (resource.owner) {
        return {
            ...resource.content,
            commission: {
                id: resource.owner.id,
                logoAssetId: resource.owner.logoAssetId,
                name: resource.owner.name
            }
        };
    } else {
        return resource.content;
    }
};

export const selectResources = <TResource>(type: string) => createSelector(
    (state: PdpState) => state.resources,
    (resources) => resources[type] as Dictionary<TResource>);